//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum SecondaryCodeEnum {
    None = 0,
    C1 = 1,
    C2 = 2,
}
